import api from '../callApi';

export const completeSentimentPoll = (
    apiRequestData,
    actionCompletedTime,
    sentimentValue
) => {
    const request = {
        ...apiRequestData,
        actionCompletedTime,
        value: sentimentValue
    };

    return api.post('Widget/CompleteSentimentPollAsync', request);
};

export const reanswerSentimentPoll = (
    apiRequestData,
    actionCompletedTime,
    sentimentValue,
    answerId
) => {
    const request = {
        ...apiRequestData,
        actionCompletedTime,
        value: sentimentValue,
        answerId
    };

    return api.post('Widget/UpdateSentimentPollAsync', request);
};



// WEBPACK FOOTER //
// ./src/utils/sentimentPoll/sentimentPollApi.js